<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <input :name="field.name" :value="value" @change="$emit('input', $event);$emit('change', '')" :type="field.subtype" :id="field.id" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required">
    <span class="file" v-for="(file, index) in files" :key="index">{{ file.name }}<span @click="removeFile(fieldIndex, index)" class="remove">&#10006;</span></span>
    <p class="small" v-if="field.description[currentLanguage]" v-html="field.description[currentLanguage]"></p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'files', 'fieldIndex', 'removeFile']
}
</script>

<style>
.file {
  display: inline-block;
  margin-right: 10px;
  letter-spacing: .05rem;
  border-radius: 2px;
  padding: 5px;
  font-size: 1.6rem;
  color: #333;
  background: #eee;
  border: 1px solid #c7c7c7;
}
.file > .remove {
  font-weight: bold;
  color: red;
  cursor: pointer;
  margin-left: 10px;
}
.file > .remove:hover {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/file.vue